import {makeMutations} from '../helpers'

const state = {
 loading: false,
};

const actions = {
 stopLoading({commit}) {
  commit('STOP_LOADING')
 },
};

const mutations = {
 ...makeMutations([
  'CHECK_LOGIN',
  'LOGIN',
 ], (state) => {
  state.loading = true
 }),
 
 ...makeMutations([
  'STOP_LOADING',
  'CHECK_LOGIN_OK',
  'CHECK_LOGIN_FAIL',
  'LOGIN_OK',
  'LOGIN_FAIL',
 ], (state) => {
  state.loading = false
 }),
};

export default {
 state,
 actions,
 mutations
}
